import { useEffect } from 'react';
import { useSlackStatusQuery } from '@/features/plugins/slack';
import { useConnectSlack } from '@/features/plugins/slack';
import { useNotificationsStore } from './store';

const SLACK_NOTIF_ID = 'slack-action-required';

export function useSlackNotificationSource() {
  const { data: status } = useSlackStatusQuery(true);
  const { connectSlack } = useConnectSlack();
  const upsert = useNotificationsStore((s) => s.upsert);
  const dismiss = useNotificationsStore((s) => s.dismiss);

  useEffect(() => {
    if (status?.connected === false) {
      upsert({
        id: SLACK_NOTIF_ID,
        kind: 'slack-action-required',
        severity: 'notice',
        title: 'Slack authorization needed',
        description: 'Connect Slack to receive notifications and updates in your workspace.',
        action: {
          label: 'Connect',
          onAction: () => void connectSlack(),
        },
        read: false,
        dismissible: false,
        createdAt: Date.now(),
      });
    } else {
      dismiss(SLACK_NOTIF_ID);
    }
  }, [status?.connected, upsert, dismiss, connectSlack]);
}
